<template>
  <v-row v-if="isMovil">
    <v-row class="py-12 mx-0 primary" align="center" justify="center">
      <v-col cols="12" sm="12" md="6" lg="5">
        <v-card light elevation="8" class="rounded-lg" data-aos="fade-right">
          <v-card-title>
            <h3 class="primary--text mb-3">
              Déjanos tus datos para brindarte más informes
            </h3>
            <p class="text-wrap font-weight-regular">
              <small>
                Nos encantaría escucharte, llena los datos y nos pondremos en
                contacto contigo.
              </small>
            </p>
          </v-card-title>
          <v-card-text class="d-flex justify-center align-center flex-column">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  name="nombre"
                  label="Nombre"
                  outlined
                  color="primary darken-3"
                  hide-details
                  v-model="name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="apellidos"
                  label="Apellidos"
                  outlined
                  color="primary darken-3"
                  hide-details
                  v-model="lastname"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="correo"
                  label="Correo electrónico"
                  outlined
                  color="primary darken-3"
                  hide-details
                  v-model="email"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="movil"
                  label="Teléfono *"
                  outlined
                  color="primary darken-3"
                  hide-details
                  v-model="phone"
                  v-mask="'##########'"
                  required
                  class="input"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="offer"
                  item-text="text"
                  item-value="key"
                  item-disabled="isDisabled"
                  text="isDisabled"
                  label="Oferta de interés*"
                  hide-details
                  outlined
                  v-model="carrer"
                  name="cp22"
                ></v-select>
              </v-col>
              <v-col cols="12" class="d-flex flex-column justify-end align-end">
                <vue-recaptcha
                  @expired="successRecaptcha = false"
                  @verify="reCAPTCHAcallback()"
                  sitekey="6LeWh6oaAAAAAK4-nrEuFXkV1g_9Pf8btl5XAWeB"
                  :loadRecaptchaScript="true"
                ></vue-recaptcha>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn 
                  color="white"
                  large
                  block
                  rounded
                  class="button-vizcaya primary--text"
                  :disabled="!successRecaptcha"
                  @click="sendForm"
                > 
                  Enviar mensaje
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-snackbar v-model="snackbar" :color="color" :timeout="3500" top>
          {{ msg }}
          <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-row>
  <v-flex v-else style="width: 41vw">
    <v-card
      elevation="8"
      light
      class="rounded-lg mx-6"
      data-aos="fade-right"
      style=""
    >
      <v-card-title>
        <h3 class="primary--text">
          Déjanos tus datos para brindarte más informes
        </h3>
      </v-card-title>
      <v-card-text class="d-flex justify-center align-center flex-column">
        <v-row>
          <v-col cols="6">
            <v-text-field
              name="nombre"
              label="Nombre*"
              outlined
              color="primary darken-3"
              hide-details
              v-model="name"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              name="apellidos"
              label="Apellidos*"
              outlined
              color="primary darken-3"
              hide-details
              v-model="lastname"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              name="correo"
              label="Correo electrónico*"
              outlined
              color="primary darken-3"
              hide-details
              v-model="email"
              required
              class="input"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              name="movil"
              label="Teléfono *"
              outlined
              color="primary darken-3"
              hide-details
              v-model="phone"
              v-mask="'##########'"
              required
              class="input"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              :items="offer"
              item-text="text"
              item-value="key"
              item-disabled="isDisabled"
              text="isDisabled"
              label="Oferta de interés*"
              hide-details
              outlined
              name="cp22"
              v-model="carrer"
            ></v-select>
          </v-col>
          <v-col cols="12" class="d-flex flex-column justify-end align-end">
            <vue-recaptcha
              @expired="successRecaptcha = false"
              @verify="reCAPTCHAcallback()"
              sitekey="6LeWh6oaAAAAAK4-nrEuFXkV1g_9Pf8btl5XAWeB"
              :loadRecaptchaScript="true"
            ></vue-recaptcha>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn 
              :loading="loading"
              color="white"
              large
              block
              rounded
              @click="sendForm"
              class="button-vizcaya primary--text"
              :disabled="loading || !successRecaptcha"
            > 
              Enviar mensaje
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" :color="color" :timeout="3500" top>
      {{ msg }}
      <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
    </v-snackbar>
  </v-flex>
</template>
<style scoped>
.text-wrap {
  word-break: break-word;
}
.input {
  height: 46px;
}
</style>

<script>
import axios from "axios";
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "Contacto",
  props: ["isMovil"],
  directives: {
    mask,
  },
  data: () => ({
    inscriptionOptions: [],
    campusSelected: "",
    windowHeight: 0,
    scrollY: 0,
    name: null,
    lastname: null,
    email: null,
    phone: null,
    state: null,
    carrer: null,
    birthday: new Date().toISOString().substr(0, 10),
    date: null,
    menu: false,
    snackbar: false,
    msg: "",
    color: "",
    loading: false,
    citites: [],
    successRecaptcha: false,
    information: {
      name_first: "",
      last_name: "",
      phone: "",
      email: "",
      campus: "",
      carrer: "",
    },
    offer: [
      { key: "4EBD213C-B93E-48D1-988C-D54F959BC211", text: "ADMINISTRACIÓN DE EMPRESAS" },
      { key: "27676024-2122-40C5-A836-D4009309D0AF", text: "CIENCIAS DE LA EDUCACIÓN" },
      { key: "52CE8D18-E9B9-4310-BC5D-8BB4872AFE4A", text: "CONTADURÍA" },
      { key: "C07B1B9D-CF73-42D7-BF6E-98CD28705008", text: "COMERCIO INTERNACIONAL" },
      { key: "C17F5334-F0F1-4693-93F6-1E116074E812", text: "DERECHO" },
      { key: "0C49D431-DD46-4401-87AF-A85C9311547C", text: "CRIMINOLOGÍA Y CRIMINALÍSTICA"},
    ],
  }),
  methods: {
    validatePhone(number) {
      let phone = /^[0-9]{10}$/;
      return phone.test(number);
    },
    onScroll(e) {
      var inscriptionsWindow = document.getElementById("main");
      this.windowHeight = inscriptionsWindow.scrollHeight;
      this.scrollY = window.scrollY;
    },
    reCAPTCHAcallback() {
      this.successRecaptcha = true;
    },
    sendMessage() {
      this.loading = true;
      if (
        this.name != null &&
        this.lastname != null &&
        this.email != null &&
        this.phone != null &&
        this.carrer != null
      ) {
        this.information.name_first = this.name;
        this.information.last_name = this.lastname;
        this.information.phone = this.phone;
        this.information.email = this.email;
        this.information.carrer = this.carrer;

        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("lastname", this.lastname);
        formData.append("email", this.email);
        formData.append("phone", this.phone);
        formData.append("state", "Uva en línea-UVAL");
        formData.append("carrer", this.carrer);
        formData.append("birthday", "");
        axios({
          method: "post",
          url: "https://www.informes-uva.tidingo.com/api/create-inscription",
          data: formData,
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        }).then((response) => {
          if (response.data.status == "200") {
            this.msg = "Mensaje enviado, pronto estaremos en contacto contigo.";
            this.color = "success";
            this.snackbar = true;
            this.name = null;
            this.lastname = null;
            this.email = null;
            this.phone = null;
            this.information.campus = null;
            this.carrer = null;
            this.birthday = new Date().toISOString().substr(0, 10);
            this.$router.push("/gracias-informes");
          } else {
            this.msg = "Algo salio mal. Intentelo nuevamente";
            this.color = "error";
            this.snackbar = true;
          }
          this.loading = false;
        });
      } else {
        this.loading = false;
        this.msg = "Complete todos los datos";
        this.color = "warning";
        this.snackbar = true;
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    sendForm(){
      if (!this.validatePhone(this.phone)) {
        this.msg = "Favor de ingresar un teléfono válido";
        this.color = "warning";
        this.snackbar = true;
        return;
      }
      this.loading = true;
      let now = moment();
      axios
        .post("https://api.salesup.com/v4/integraciones/P25AP00653DF1-17A5-4381-A221-6595262C17B2", {
          nombre: this.name,
          apellidos: this.lastname,
          correo: this.email,
          movil: this.phone,
          cp22: this.carrer,
          // ----- AD'S
          url: "https://uvaenlinea.uva.edu.mx",
          referrer: "https://www.google.com/",
          browser: "Chrome 105",
          esMovil: this.isMovil,
          gclid: "",
          fbclid: "",
          utm_source: "https://uvaenlinea.uva.edu.mx/modelo-educativo",
          utm_medium: "Organico",
          utm_campaign: "",
          utm_term: "",
          utm_date: now.toISOString(),
          utm_content: ""
      }).then(response => {
        if(response.data[0].msg == "Ok"){
          this.loading = false;
          this.name = null;
          this.lastname = null;
          this.email = null;
          this.phone = null;
          this.information.campus = null;
          this.carrer = null;
          this.birthday = new Date().toISOString().substr(0, 10);
          this.$router.push("/gracias-informes");
        }else{
          this.loading = false;
        }
      }).catch(error =>{
        this.loading = false;
      })
    }
  },
  mounted() {},
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.birthday);
    },
    ...mapState({
      //offer: (state) => state.home.offer,
    }),
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>
